export const state = {
    isMobile: false,
    isDebug: false,

    dashboard: {
        selectedData: 0, // no selected
    },
    modal: {
        isModalShown: false,
    },
    userPreference: {
        // grid, list, table
        viewLayout: {
            folder: '',
            file: '',
            pinFolderFile: '',

            // trash page
            trashPageFolderFile: '',

            // pin page
            pinPageFolder: '',
            pinPageFile: '',

            // public page
            publicPageFile: '',

            // my office archive page or my public page
            myPublicPageFile: '',
        }, 
        // group by
        groupBy: ''
    },
    selectedSearchType: '',
}


export const getters = {
}


export const mutations = {
    // IS MOBILE
    setIsMobile: (state, data) => {
        state.isMobile = data;
    },
    // IS DEBUG
    setIsDebug: (state, data) => {
        state.isDebug = data;
    },
    // DASHBOARD ITEM
    selectDashboard: (state, data) => {
        state.dashboard.selectedData = data;
    },
    // MODAL
    setModalVisibility: (state, bool) => {
        state.modal.isModalShown = bool;
    },
    // FILE MANAGER VIEW LAYOUT
    setFileViewLayout: (state, data) => {
        state.userPreference.viewLayout.file = data;

        saveState('USER_PREFERENCE', state.userPreference);
    },
    setFolderViewLayout: (state, data) => {
        state.userPreference.viewLayout.folder = data;

        saveState('USER_PREFERENCE', state.userPreference);
    },
    setPinFolderFileViewLayout: (state, data) => {
        state.userPreference.viewLayout.pinFolderFile = data;

        saveState('USER_PREFERENCE', state.userPreference);
    },
    setTrashPageFolderFileViewLayout: (state, data) => {
        state.userPreference.viewLayout.trashPageFolderFile = data;

        saveState('USER_PREFERENCE', state.userPreference);
    },
    setPinPageFolderViewLayout: (state, data) => {
        state.userPreference.viewLayout.pinPageFolder = data;

        saveState('USER_PREFERENCE', state.userPreference);
    },
    setPinPageFileViewLayout: (state, data) => {
        state.userPreference.viewLayout.pinPageFile = data;

        saveState('USER_PREFERENCE', state.userPreference);
    },
    setPublicPageFileViewLayout: (state, data) => {
        state.userPreference.viewLayout.publicPageFile = data;

        saveState('USER_PREFERENCE', state.userPreference);
    },
    setGroupBy: (state, data) => {
        state.userPreference.groupBy = data;

        saveState('USER_PREFERENCE', state.userPreference);
    },
    setMyPublicPageFileViewLayout: (state, data) => {
        state.userPreference.viewLayout.myPublicPageFile = data;

        saveState('USER_PREFERENCE', state.userPreference);
    },
    setSelectedSearchType: (state, data) => {
        state.selectedSearchType = data;
    }
}


export const actions = {
}



function saveState(key, state) {
    window.localStorage.setItem(key, JSON.stringify(state))
}